import React from "react";
import "./style.scss";
import contractIcon from "../../../assets/icons/contract.svg";
import bestTradeIcon from "../../../assets/icons/best-trade.svg";
import worstTradeIcon from "../../../assets/icons/worst-trade.svg";
import avgWinIcon from "../../../assets/icons/avg-win.svg";
import avgLossIcon from "../../../assets/icons/avg-loss.svg";
import noOfTradesIcon from "../../../assets/icons/no-of-trades.svg";
import winRateIcon from "../../../assets/icons/win-rate.svg";
import profitFactorIcon from "../../../assets/icons/profit-factor.svg";
import { FormatUSD, getClassForValue } from "../../../utils/helpers/string";

function Statistics({ data }) {
  const newData = data?.account_metrics?.calculated_data;

  const statisticsData1 = [
    {
      title: "Best Trade",
      value: newData?.highest,
      formatUsd: true,
      icon: bestTradeIcon,
    },
    {
      title: "Worst Trade",
      value: newData?.worst_trade,
      formatUsd: true,
      icon: worstTradeIcon,
    },
    {
      title: "Avg Win",
      value: newData?.average_profit,
      formatUsd: true,
      icon: avgWinIcon,
    },
    {
      title: "Avg Loss",
      value: newData?.average_loss,
      formatUsd: true,
      icon: avgLossIcon,
    },
  ];

  const statisticsData2 = [
    {
      title: "No of Trades",
      value: newData?.total_trades || "N/A",
      icon: noOfTradesIcon,
      formatUsd: false,
    },
    {
      title: "Win Rate",
      value: newData?.win_rate + "%",
      icon: winRateIcon,
      formatUsd: false,
    },
    {
      title: "Contracts",
      value: newData?.lots || "N/A",
      icon: contractIcon,
      formatUsd: false,
    },
    {
      title: "Profit Factor",
      value: newData?.profit_factor.toFixed(2) || "N/A",
      icon: profitFactorIcon,
      formatUsd: false,
    },
  ];

  return (
    <div className="statistics">
      <div className="statistics-box-wrapper">
        {statisticsData1.map((data, index) => (
          <StatisticsBox1 key={index} data={data} />
        ))}
      </div>
      <div className="statistics-box-wrapper">
        {statisticsData2.map((data, index) => (
          <StatisticsBox2 key={index} data={data} />
        ))}
      </div>
    </div>
  );
}

export default Statistics;

export const StatisticsBox1 = ({ data }) => {
  return (
    // <div className="statistics-box">
    //   <img src={data.icon} alt="" />
    //   <div>
    //     <p>{data.title}</p>
    //     {data?.formatUsd === true ? (
    //       <span className={getClassForValue(data?.value)}>
    //         {FormatUSD(data.value)}
    //       </span>
    //     ) : (
    //       <span>{data.value}</span>
    //     )}
    //   </div>
    // </div>
    <div className="statistics-data-box">
      <div className="account-data-left">
        <p>{data.title}</p>
      </div>
      <div className="account-data-right">
        {data?.formatUsd === true ? (
          <span className={getClassForValue(data?.value)}>
            {FormatUSD(data.value)}
          </span>
        ) : (
          <span>{data.value}</span>
        )}
      </div>
    </div>
  );
};

export const StatisticsBox2 = ({ data }) => {
  return (
    // <div className="statistics-box">
    //   {/* <img src={data.icon} alt="" /> */}
    //   <div>
    //     <p>{data.title}</p>
    //     {data?.formatUsd === true ? (
    //       <span className={getClassForValue(data?.value)}>
    //         {FormatUSD(data.value)}
    //       </span>
    //     ) : (
    //       <span>{data.value}</span>
    //     )}
    //   </div>
    // </div>
    <div className="statistics-data-box">
      <div className="account-data-left">
        <p>{data.title}</p>
      </div>
      <div className="account-data-right">
        {data?.formatUsd === true ? (
          <span className={getClassForValue(data?.value)}>
            {FormatUSD(data.value)}
          </span>
        ) : (
          <span>{data.value}</span>
        )}
      </div>
    </div>
  );
};
